export const getErrorMessage = (err) =>
  err?.response?.data?.error ||
  err?.response?.data?.errorMessage ||
  err?.response?.data?.message ||
  err?.message ||
  ''
